// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header___2_IcP"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/ClientDetails/ClientNumbers/styles.css
// module id = 3178
// module chunks = 0